// OBT F3-E — Sadece okunmamış sayacı (panel butonu rozeti için, hafif poll).
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchObtUnreadCount } from '../notificationApi';

function isCanceled(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

const POLL_MS = 60_000;

export function useObtUnreadCount({ enabled = true } = {}) {
  const [count, setCount] = useState(0);
  const abortRef = useRef(null);
  const timerRef = useRef(null);

  const load = useCallback(async () => {
    if (!enabled) {
      setCount(0);
      return;
    }
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    try {
      const c = await fetchObtUnreadCount({ signal: controller.signal });
      if (!controller.signal.aborted) setCount(Number(c) || 0);
    } catch (error) {
      if (!isCanceled(error)) setCount((prev) => prev);
    }
  }, [enabled]);

  useEffect(() => {
    load();
    if (enabled) timerRef.current = setInterval(load, POLL_MS);
    return () => {
      abortRef.current?.abort();
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [load, enabled]);

  return { count, reload: load };
}
